// extracted by mini-css-extract-plugin
export default {"container":"pagenotfound_container__JCCgp","code":"pagenotfound_code__ammQl"};